module.exports = __webpack_public_path__ + "static/media/2.ad3ae1a0.jpg";